import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AlertChip from '../AlertChip';

import Toolbar from '@material-ui/core/Toolbar';

import moment from 'moment';
import setting from "../../config/setting";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let id = 0;
function createData(PO_ID, flags, CreatedBy, Created_Date, Vendor_Name) {
    id += 1;
    return { id, PO_ID, flags, CreatedBy, Created_Date, Vendor_Name};
}


class DuplicateTxnTable extends Component {

    render() {
        //console.log("duplicate transctions data!")
        //console.log(this.props.data);
        const classes = this.props;
        // console.log("Txn props:");
        // console.log(this.props);
        let i = 0;
        let k = 0;
        return (
            <div className={classes.root}>
                <Toolbar>Duplicate Transactions</Toolbar>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {this.props.header.map(header =>{
                                k++
                                return(
                                    <TableCell style = {{ whiteSpace: 'nowrap' }} key = {k}>{header.replace(/_/g, ' ')}</TableCell>
                                )
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.data.map(n => {
                            return (
                                <TableRow key={n.id}>
                                    {this.props.header.map(header =>{
                                        if (header == "flags"){
                                            return (<TableCell style={{ position: "sticky", left: "0vw"   }}>
                                                {n.flags["High Risk"].map(e => {
                                                    return (<div/>)
                                                })}
                                                {n.flags["Medium Risk"].map(e => {
                                                    return (<div />)
                                                })}
                                                {n.flags["Low Risk"].map(e => {
                                                    return (<div />)

                                                    {/*i++;
                                                    return (<AlertChip
                                                        key={i}
                                                        label={e}
                                                        color={'low'}
                                                        username={this.props.username}
                                                        count={this.props.count}
                                                        taskRefresh = {this.props.taskRefresh}
                                                        metadata = {this.props.metadata}
                                                        //avatar={n.flags.hightr}
                                                        //style={{ margin: 2 }}
                                                    />);*/}
                                                })}

                                            </TableCell>);
                                        } else {
                                            return(
                                                <TableCell>{(header == "created_date" || header == "approved_date") ? moment(n[header]).format(setting.date_format) : n[header]}</TableCell>
                                            );
                                        }
                                    })
                                    }
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </div>
        )
    }
}
export default withStyles(styles)(DuplicateTxnTable)


// WEBPACK FOOTER //
// ./src/components/Routines/DuplicateTxnTable.js